import { Component, OnInit, Input, inject, DestroyRef } from "@angular/core";
import { takeUntilDestroyed } from "@angular/core/rxjs-interop";
import { MatExpansionModule } from "@angular/material/expansion";
import { MatIcon } from "@angular/material/icon";
import { HistoryMutationModel } from "@app/incident/models/history-change-model";
import { IncidentService } from "@app/incident/services/incident.service";
import { DateTimeDisplayPipe } from "@app/shared/pipes/date-time-display.pipe";

@Component({
    selector: "incident-history",
    templateUrl: "incident-history.component.html",
    styleUrls: ["incident-history.component.scss"],
    imports: [MatExpansionModule, MatIcon, DateTimeDisplayPipe]
})
export class IncidentHistoryComponent implements OnInit {
    @Input() incidentId: string;

    private readonly incidentService = inject(IncidentService);
    private readonly destroyRef = inject(DestroyRef);

    public mutations: HistoryMutationModel[];
    public dataLoaded = false;

    ngOnInit() {
        this.incidentService
            .getIncidentMutations(this.incidentId)
            .pipe(takeUntilDestroyed(this.destroyRef))
            .subscribe((mutations) => {
                this.mutations = mutations;
                this.dataLoaded = true;
            });
    }

    onMutationOpened(mutation: HistoryMutationModel) {
        if (mutation.changes && mutation.changes.length > 0) {
            return;
        }

        this.incidentService
            .getIncidentChanges(this.incidentId, mutation.dateChange)
            .subscribe((changes) => {
                mutation.changes = changes;
            });
    }
}
